/**
 * The sentence that names the blacklist entry a blocked send matched (PREC-2548), by the entry's
 * origin. An unsubscribe and a competitor read differently from a plain Do Not Contact entry,
 * because they are removed differently: an unsubscribe cannot be overridden at all.
 */
export const blacklistBlockLabelKey = (origin: string | null): string => {
	if (origin === "UNSUBSCRIBED_BY_LEAD") {
		return "outbox.failure.BLACKLISTED.matchedUnsubscribed";
	}

	if (origin === "COMPETITOR") {
		return "outbox.failure.BLACKLISTED.matchedCompetitor";
	}

	return "outbox.failure.BLACKLISTED.matched";
};
